import {
  Box,
  Card,
  CardContent,
  Typography,
  Grid,
  Chip,
  Stack,
} from "@mui/material";
import LocationOnIcon from "@mui/icons-material/LocationOn";

const SelectedSiteVisit = ({ flatData, data }) => {
  /* -------------------------------
     NORMALIZE PROPERTY DATA
  --------------------------------*/
console.log(data);
debugger
  const propertySource = data?.apartment
    ? data.apartment
    : Array.isArray(data)
    ? data[0]
    : {};

  const propertyName =
    propertySource?.ApartmentName || propertySource?.PropertyName || "";

  const address = propertySource?.Address || "";
  const city = propertySource?.City || "";

  /* -------------------------------
     NORMALIZE FLAT DATA
  --------------------------------*/

  const flat =
    Array.isArray(flatData)
      ? flatData[0]
      : flatData || {};

  /* -------------------------------
     RENDER
  --------------------------------*/

  return (
    <Box sx={{ maxWidth: 900, mx: "auto", mt: 4 }}>
      <Card
        sx={{
          borderRadius: 3,
          boxShadow: "0 8px 25px rgba(0,0,0,0.08)",
        }}
      >
        <CardContent>
          {/* Property Title */}
          <Typography variant="h5" fontWeight={700}>
            {propertyName || "Property Name"}
          </Typography>

          {/* Location */}
          {(address || city) && (
            <Stack
              direction="row"
              spacing={1}
              alignItems="center"
              sx={{ color: "text.secondary", mt: 0.5, mb: 2 }}
            >
              <LocationOnIcon fontSize="small" color="primary" />
              <Typography variant="body2">
                {address}{address && city ? ", " : ""}{city}
              </Typography>
            </Stack>
          )}

          {/* Flat Info */}
          {(flat?.FlatName || flat?.PropertyName) && (
            <>
              <Typography variant="h6" fontWeight={600} mt={1}>
                {flat?.FlatName || flat?.PropertyName}
              </Typography>

              {(flat?.FloorNo || flat?.Facing) && (
                <Typography color="text.secondary" mb={3}>
                  {flat?.FloorNo && `Floor ${flat.FloorNo}`}
                  {flat?.FloorNo && flat?.Facing && " • "}
                  {flat?.Facing && `${flat.Facing} Facing`}
                </Typography>
              )}
            </>
          )}

          {/* Details Grid */}
          <Grid container spacing={2}>
            {flat?.Price && (
              <Grid  xs={6}>
                <Typography variant="body2" color="text.secondary">
                  Price
                </Typography>
                <Typography fontWeight={600}>
                  ₹ {flat?.Price} {flat?.PriceType && `(${flat.PriceType})`}
                </Typography>
              </Grid>
            )}

            {flat?.MarketPrice && (
              <Grid  xs={6}>
                <Typography variant="body2" color="text.secondary">
                  Market Price
                </Typography>
                <Typography fontWeight={600}>
                  ₹ {flat?.MarketPrice}
                </Typography>
              </Grid>
            )}

            {flat?.SizeInSqFt && (
              <Grid xs={6}>
                <Typography variant="body2" color="text.secondary">
                  Size
                </Typography>
                <Typography fontWeight={600}>
                  {flat?.SizeInSqFt} Sq.Ft
                </Typography>
              </Grid>
            )}

            {flat?.AdvancePayment && (
              <Grid xs={6}>
                <Typography variant="body2" color="text.secondary">
                  Advance Payment
                </Typography>
                <Typography fontWeight={600}>
                  ₹ {flat?.AdvancePayment}
                </Typography>
              </Grid>
            )}

            {flat?.Status && (
              <Grid xs={6}>
                <Typography variant="body2" color="text.secondary">
                  Status
                </Typography>
                <Chip
                  label={flat?.Status}
                  color="success"
                  size="small"
                  sx={{ mt: 0.5 }}
                />
              </Grid>
            )}
          </Grid>
        </CardContent>
      </Card>
    </Box>
  );
};

export default SelectedSiteVisit;
